class CartNotificationXs extends HTMLElement {
  constructor() {
    super();

    this.notification = document.querySelector("cart-notification-xs");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    /*
    this.notification.addEventListener("pointerover", () => {
      document.body.style.overflowY = "hidden";
    });

    this.notification.addEventListener("pointerout", () => {
      document.body.style.overflowY = "initial";
    });*/

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    /*
    window.addEventListener("scroll", () => {
      let ua = navigator.userAgent;
      if (
        (ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
        ua.indexOf("Mobile") > 0
      ) {
      }
    });
    */

    const checkboxes = this.querySelectorAll('input[type="checkbox"]');
    const submitButton = this.querySelectorAll('button[type="submit"]');

    function updateSubmitButtonState() {
      let isChecked = false;
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          isChecked = true;
          checkbox.parentElement.classList.add("notification-selected");
        } else {
          checkbox.parentElement.classList.remove("notification-selected");
        }
      });

      if (document.getElementById("cart-notification-xs-submit") != null) {
        document.getElementById("cart-notification-xs-submit").disabled =
          !isChecked;

        if (!isChecked) {
          document.getElementById(
            "cart-notification-xs-submit"
          ).style.opacity = 0.5;
        } else {
          document.getElementById(
            "cart-notification-xs-submit"
          ).style.opacity = 1;
        }
      }

      //submitButton.disabled = !isChecked;
    }

    checkboxes.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.addEventListener("change", updateSubmitButtonState);
      } else {
        checkbox.parentElement.classList.add("notification-disabled");
      }
    });

    updateSubmitButtonState();
  }

  open() {
    /*
    this.notification.classList.add(
      "notification-xs-animate",
      "notification-xs-active"
    );
    */

    /*
    tippy("#" + "tooltip-notification-xs-list", {
      placement: "top-start",
      allowHTML: true,
      content:
        "<p>Redeem by adding any 4 FKM Rubber Straps to your cart. <br><br>The discount will be reflected automatically. </p>",
      interactiveBorder: 1,
    });
    */

    document
      .getElementById("cart-notification-xs")
      .classList.add("notification-xs-active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    const checkboxes = this.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    document.getElementById("cart-notification-xs-submit").disabled = true;
    document.getElementById("cart-notification-xs-submit").style.opacity = 0.5;

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    //this.notification.classList.remove("notification-xs-active");
    document
      .getElementById("cart-notification-xs")
      .classList.remove("notification-xs-active");

    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    //if (this.header) this.header.reveal();

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification-xs")
    ) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification-xs", CartNotificationXs);
